import React from "react";
import { Pagination, Form } from "react-bootstrap";
import { ChevronLeft, ChevronRight } from "lucide-react";

const NewPagination = ({
  totalPages = 1,
  currentPage = 1,
  onPageChange,
  recordsPerPage = 10,
  onRecordsPerPageChange,
}) => {
  // Logic to generate page numbers with ellipsis (...)
  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", currentPage, "...", totalPages);
      }
    }
    return pages;
  };

  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 mt-4 px-2">
      {/* Records Per Page Dropdown */}
      <div className="d-flex align-items-center gap-2">
        <Form.Select
          size="sm"
          value={recordsPerPage}
          onChange={(e) => onRecordsPerPageChange(Number(e.target.value))}
          style={{ width: "70px", borderRadius: "8px" }}
        >
          <option value={9}>10</option>
          <option value={12}>20</option>
          <option value={24}>50</option>
        </Form.Select>
        <span className="text-muted small">Records per page</span>
      </div>

      {/* Page Numbers and Navigation */}

      <div className="d-flex gap-1 mx-2">
        {getPageNumbers().map((page, index) => (
          <button
            key={index}
            onClick={() => typeof page === "number" && onPageChange(page)}
            className={`btn btn-sm px-3 ${
              currentPage === page
                ? "btn-primary"
                : "btn-light text-muted border-0"
            }`}
            style={{
              borderRadius: "8px",
              backgroundColor: currentPage === page ? "#753FC9" : "transparent",
              borderColor: currentPage === page ? "#753FC9" : "transparent",
              fontWeight: "500",
            }}
            disabled={page === "..."}
          >
            {page}
          </button>
        ))}
      </div>
      <div className="d-flex align-items-center gap-2 flex-wrap justify-content-center">
        <button
          className="btn btn-outline-light text-muted border d-flex align-items-center gap-1"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={{
            borderRadius: "8px",
            fontSize: "14px",
          }}
        >
          <ChevronLeft size={16} /> Previous
        </button>

        <button
          className="btn btn-outline-light text-muted border d-flex align-items-center gap-1"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={{ borderRadius: "8px", fontSize: "14px" }}
        >
          Next <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default NewPagination;
